import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ILegalDocument } from '../../types/document';

export enum EDocumentActionTypes {
  SetDocument = 'DOCUMENT/SET_STATE',
}

export type TSetDocument = ITypedReduxAction<EDocumentActionTypes.SetDocument, ILegalDocument>;

/**
 * Redux action, который записывает в store юр документ
 * @param document ILegalDocument
 */
export const setDocument = actionGenerator<EDocumentActionTypes.SetDocument, ILegalDocument>(
  EDocumentActionTypes.SetDocument,
);
